import React from "react";
import "../css/home.css";
import profile from "../PicsAsset/profile.jpg";
import { FaReact, FaVuejs } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import reactpic from "../PicsAsset/react.jpg"
import Vuetodopic from "../PicsAsset/todoVue.jpg"
import vanilajsCal from "../PicsAsset/calculator.jpg"
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Home = () => {
// const handleemail=()=>{
//   window.location = "mailto:missionaryabra@gmail.com";
// }

const handlereact=()=>{
  window.open("https://altschoolexam-one.vercel.app/", "_blank");
}
const handleVuetodo=()=>{
  window.open("https://vue-note.vercel.app/", "_blank");

}
const handleJsCalculation=()=>{
  window.open("https://circle33-calculator.netlify.app/", "_blank");
}

  return (
    <div className="wrap font-[Philosopher] text-[#faf5ff]">
      <div className="intro">
        <div className="profilediv">
          <img src={profile} alt="profile img"></img>
        </div>
        <div>
          <div className="words">
          <div className="expintro"> Explicit intro.</div>
            <p className="words1">
              I'm Abraham Olowu, a frontend engineer based in Lagos, Nigeria. I
              write Javascript, React and Vue, I design web applications
              and aslo available to contribute to existing projects
            </p>
            <p className="inProgress">Kindly note ... Next.js in progress</p>
          </div>
        </div>
      </div>

      {/* blog space */}

      <div className="blog">Blog space watch out !!!</div>

      <div className="here">Here are some of my prevoius projects </div>
      <div className="project ">
        <div className="reactprofolio pro">
          <div className="con1">
            <p>Github profolio with:</p>
            <p><FaReact></FaReact></p>
          </div>
          <div className="reactpic">
            <img src={reactpic} alt="react" style={{cursor: "pointer"}} onClick={handlereact}></img>
          </div>
        </div>

        <div className="vuetodo pro">
          <div className="con1">
            <p> Mini todo app with:</p>
            <FaVuejs></FaVuejs>
          </div>
          <div className="reactpic">
            <img src={Vuetodopic} alt="react" onClick={handleVuetodo} style={{cursor: "pointer"}} ></img>
          </div>
        </div>


        <div className="calculator pro">
          <div className="con1">
            <p> calculator with:</p>
            <IoLogoJavascript></IoLogoJavascript>
          </div>
          <div className="reactpic">
            <img src={vanilajsCal} alt="react" onClick={handleJsCalculation} style={{cursor: "pointer"}}></img>
          </div>
        </div>
      </div>
      {/* bring work */}

      <div className="sayhi">
        <div className="sayhiHead">
          <p> Key Objectives</p>
        </div>
        <div className="sayhidown">
            <p>I'm looking forward to new project and collaborations. Say Hi and let begin</p> 
           
              <div className="sayhibuttondiv"  >
        
              <Link to='/sayhi'><p>Say Hi</p></Link> 
              <FaLongArrowAltRight className="right1" />
              
            </div>
        </div>
      </div>
         </div>
  );
};

export default Home;
